<!-- <nav *ngIf="type !='logged'" class="navbar navbar-expand-lg navbar-light bg-light header">
    <div class="logo"><a routerlink="/login"><img src="assets/logo-4.png"></a></div>
</nav>
 -->

<nav class="navbar-expand-lG navbar-light bg-light header">
  <div class="container-fluid dashboard-container">
    <div class="row">

      <div class="col">
        <div class="row">
          <div class="col-md-2">
            <div class="logo" style="display: flex; align-items: center;">
              <button (click)="toggleSideNav()" class="collapse_icon"><i class="fas fa-list"></i></button>
              <a><img src="assets/logo-4.png" /></a>

            </div>
          </div>
        </div>
      </div>
      <div *ngIf="user?.isEmailVarified == true" class="m-auto d-flex justify-content-end align-items-center nav-btn">
        <div>
          <button type="button" (click)="navigateToAds(content)" class="creatAdButton btn btn-style cursor">
            Create Ads
          </button>
        </div>
        <div class="mr-4 bell-icon">
          <div ngbDropdown [autoClose]="'outside'" class="d-inline-block">
            <div id="dropdownBasic2" ngbDropdownToggle>
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor"
                class="position-relative  bi bi-bell" viewBox="0 0 16 16">
                <path
                  d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
              </svg>
              <small class="position-absolute count-bell font-weight-bold">{{unreadNotificationCount}}</small>
            </div>

            <div class="notification-dropdown" ngbDropdownMenu aria-labelledby="dropdownBasic2">
              <div class="container">
                <div class="controls d-flex flex-wrap">
                  <div class="mail w-75">
                    <a href="#" class="current">Notifications </a>
                  </div>
                </div>
                <div class="content">
                  <ul class="itemList">
                    <li *ngFor="let notfication of allNotifications" (click)="markAsRead(notfication)">
                      <a href="javascript:void(0)" ngbDropdownItem class="user1"
                        [class.read-notification]="notfication.isRead">
                        <img [src]="imageUrl(notfication?.from?.photo)" (error)="changeSource($event)" />
                        <h5>
                          <strong>{{notfication?.from?.name}}</strong>
                          {{notfication.description }}
                          <br>
                          <span> {{convertTimeAgo(notfication?.createdAt)}} </span>
                        </h5>
                        <i class="fas fa-circle" *ngIf="!notfication.isRead"></i>
                      </a>
                    </li>
                    <div class="w-100 text-center py-3" *ngIf="allNotifications?.length === 0">
                      No Notification Found
                    </div>
                  </ul>
                </div>
              </div>


            </div>
          </div>
        </div>
        <div class="mr-4 message-icon" (click)="goToChat()">
          <div ngbDropdown class="d-inline-block">
            <div id="dropdownBasic1" ngbDropdownToggle>
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor"
                class="position-relative  bi-chat-right-text" viewBox="0 0 16 16">
                <path
                  d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z" />
                <path
                  d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
              </svg>
              <small class="position-absolute count-message font-weight-bold">{{notificationCount}}</small>

            </div>

            <div class="notification-dropdown" ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <div class="container">
                <div class="controls d-flex flex-wrap">
                  <div class="mail w-75">
                    <a href="#" class="current">Inbox </a>
                  </div>
                </div>
                <div class="content">
                  <ul class="itemList">
                    <li>
                      <h5>
                      </h5>
                    </li>
                  </ul>
                </div>
              </div>


            </div>
          </div>

        </div>
        <div *ngIf="user?.name" class="mb-2 cursor-pointermb-4 d-flex justify-content-center align-items-center"
          (click)="isOpen = !isOpen">
          <div class="dropdownnn">
            <div class="menu-trigger username-d" style="width: unset !important">
              <!-- <div> -->
              <span style="margin-left: 22px;">{{user.name}}
                <span style="margin-left: 5px;margin-right: 5px;"><i [ngClass]="
                isOpen
                  ? 'gg-chevron-up mr-2 font-weight-bold'
                  : 'gg-chevron-down mr-2 font-weight-bold'
              "></i></span> </span>
              <img class="landing-profile-logo" [src]="user?.photo | merchantProfilePhoto"
                (error)="onImgError($event, 'assets/default-user.jpg')" alt="profile_pic" />
              <!-- </div> -->
              <div class="menu custColor" *ngIf="isOpen" [@dropDownMenu]>
                <!-- <div  class="menu-item" (click)="updateProfile()">
                  Update Profile
                </div> -->
                <div class="menu-item" (click)="homePage()">
                  Homepage
                </div>
                <div class="menu-item" (click)="personalDashboard()">
                  Personal Dashboard
                </div>
                <div (click)="logout()" class="menu-item">Logout</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</nav>


<ng-template #content let-modal>

  <button type="button" class="btnn btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">X</button>

  <div class="modal-body modal-body1">
    <form>
      <div class="mb-3 d-flex flex-wrap text-center justify-content-center">
        <!-- <img class="logoo" src="../../assets/logo-5.png" /> -->
        <h3 class="w-100 ">Subscription Required</h3>
        <h6 class="w-100 my-3">Would you like to upgrade your business?</h6>
        <p class="w-100 mt-2">
          <button (click)="goToSubscribe()" class="btn btn-primary">Review Plans</button>
          <button (click)="goToDashboard()" class="btn btn-danger ml-2">Cancel</button>
        </p>
      </div>
    </form>
  </div>
</ng-template>